import React from 'react';
import PrayerButtonGrid from '../components/PrayerButtonGrid';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const categories = [
  'daily',
  'christian',
  'catholic',
  'father',
  'mother',
  'wife_prayer',
  'husband_prayer',
  'son_prayer',
  'daughter_prayer',
  'brother_prayer',
  'sister_prayer',
  'friend_prayer',
  'health_prayer',
  'finances_prayer',
  'world_prayer',
  'extended_family_prayer'
];

const labels = {
  daily: 'Diario',
  christian: 'Cristiano',
  catholic: 'Catolico',
  father: 'Padre',
  mother: 'Madre',
  wife_prayer: 'Esposa',
  husband_prayer: 'Esposo',
  son_prayer: 'Hijo',
  daughter_prayer: 'Hija',
  brother_prayer: 'Hermano',
  sister_prayer: 'Hermana',
  friend_prayer: 'Amigo',
  health_prayer: 'Salud',
  finances_prayer: 'Finanzas',
  world_prayer: 'Mundo',
  extended_family_prayer: 'Familia Extendida'
};

function SpanishHomePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Elige una Oración</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) => navigate(`/es/prayer/${cat}`, { state: { from: '/es' } })}
      />

      {/* ➕ Botón de Más Oraciones */}
      <div className="text-center mt-3">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate('/es/more')}>
          Más Oraciones
        </Button>
      </div>

    </Container>
  );
}

export default SpanishHomePage;
